import React from 'react';
import { useField } from 'react-final-form';
import { FormattedMessage, useIntl } from 'react-intl';

import { formatUndefined } from 'utils/formUtils';

import Icon from '../ui/Icon';
import Textarea from '../ui/Textarea';
import CardActions from '../ui/Card/CardActions';
import Button, { ButtonType } from '../ui/Button';

const QuestionCardActions: React.FC<{ name: string }> = ({ name }) => {
  const intl = useIntl();

  const {
    input: { value: comment, onChange: handleChangeComment },
    meta: { initial: initialComment },
  } = useField<string>(`${name}.comment`, {
    subscription: { value: true, initial: true },
    format: formatUndefined,
  });

  const [shouldShowComment, setShouldShowComment] = React.useState<boolean>(Boolean(comment));

  const handleClick = React.useCallback(() => setShouldShowComment(true), []);

  const handleCommentChange = React.useCallback(
    (event: React.ChangeEvent<HTMLTextAreaElement>) => handleChangeComment(event.target.value),
    [handleChangeComment],
  );

  return (
    <div>
      <CardActions name={name} />
      {!shouldShowComment && (
        <>
          <div className="w-full h-px bg-border-default mt-xs" />
          <Button
            type={ButtonType.LIGHT}
            className="w-full my-1 pb-0! text-button-xs!"
            testId="AddComment"
            onClick={handleClick}
          >
            <div className="flex justify-center items-center text-button-xs!">
              <Icon className="fb-icon--new-message mr-xs text-button-xs!" />
              <FormattedMessage id="repairOrder.addComment" defaultMessage="Add comment" />
            </div>
          </Button>
        </>
      )}
      {shouldShowComment && (
        <>
          <div className="w-full h-px bg-border-default mt-5" />
          <Textarea
            autoFocus={!initialComment}
            label={intl.formatMessage({
              id: 'repairOrder.comment',
              defaultMessage: 'Comment',
            })}
            inputClassName="mb-0!"
            className="bg-transparent!"
            value={comment}
            data-testid="comment"
            rows={3}
            onChange={handleCommentChange}
          />
        </>
      )}
    </div>
  );
};

export default QuestionCardActions;
